<script lang="ts">
  import { fade } from "svelte/transition";
  import CheckCircle from "../icons/CheckCircle.svelte";

  interface Props {
    message: string;
  }

  const { message }: Props = $props();
</script>

<div
  class="mb-4 flex min-w-max items-center gap-2.5 rounded-xl border border-blue-200 bg-blue-50 px-3 py-2.5 text-sm whitespace-nowrap"
  out:fade
>
  <div class="flex items-center justify-center text-pri-700">
    <CheckCircle />
  </div>
  <span class="text-gray-900">{message}</span>
</div>
